/* ============================================================================
   PDP_004 — Product gallery B variant (Intelligems A/B test)

   Defines <product-slider-b>, the slider for the custom metafield gallery. It
   reuses the theme's existing ProductSlider (Flickity) so behaviour matches the
   default gallery exactly, but differs in two ways:

   1. It only initialises when <body class="et-pdp-b"> is present (the Intelligems
      B variant). On the control variant — or with no experiment running — it
      stays dormant and hidden (see assets/pdp-gallery-b.css), so the default
      gallery is never affected.
   2. It scopes its thumbnail container to its own .pdp-gallery-b wrapper instead
      of the first .product-thumbnail-container on the page (which is control's).

   The B gallery markup is only emitted when the metafield is populated
   (snippets/product-gallery-b.liquid), so this script is only loaded then.
   ========================================================================== */
(function () {
  var REVEAL_CLASS = 'et-pdp-b';

  function isBActive() {
    return document.body.classList.contains(REVEAL_CLASS);
  }

  function defineElement() {
    if (customElements.get('product-slider-b')) {
      return true;
    }
    var Base = customElements.get('product-slider');
    // Base slider class + Flickity must both be available before we extend.
    if (!Base || typeof Flickity === 'undefined') {
      return false;
    }

    class ProductSliderB extends Base {
      connectedCallback() {
        if (isBActive()) {
          this.startB();
          return;
        }
        // Intelligems may assign the variant after load — wait for the class.
        this._bObserver = new MutationObserver(function () {
          if (isBActive()) {
            this._bObserver.disconnect();
            this._bObserver = null;
            this.startB();
          }
        }.bind(this));
        this._bObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      disconnectedCallback() {
        if (this._bObserver) {
          this._bObserver.disconnect();
          this._bObserver = null;
        }
        if (this.flkty) {
          try {
            this.flkty.destroy();
          } catch (e) {}
        }
      }

      startB() {
        if (this.flkty) {
          return; // already initialised
        }
        // Scope to this B gallery's own wrapper (not control's containers).
        this.product_container = this.closest('.pdp-gallery-b');
        if (!this.product_container) {
          return;
        }
        this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
        this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

        // Inherited from ProductSlider: builds Flickity + thumbnail/zoom events.
        this.setOptions();
        this.init();
      }
    }

    customElements.define('product-slider-b', ProductSliderB);
    return true;
  }

  if (!defineElement()) {
    // product.js / vendor (Flickity) not ready yet — poll briefly.
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (defineElement() || tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }
})();
